import React, { useContext, useState } from 'react';
import classNames from 'classnames';

import WishlistIcon from 'jl-design-system/elements/icons-jb/Wishlist24PxOutlined';
// eslint-disable-next-line import/no-named-as-default
import AccountButton from '../account-button/AccountButton';
import AccountMenu from '../account-menu/AccountMenu';
import formatGreeting from '../../utils/user/format-greeting';
import { isDesktop, isTouchDevice } from '../../utils/device/identifyDevice';
import { UserContext } from '../../scaffold/UserContext';
import { getAccountLinks } from '../links';

import styles from './account-links.scss';
import EnvVarsFeaturesContext from '../../scaffold/EnvVarsFeaturesContext';

const AccountLinks = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    envVars: { accountBaseUrl },
    features: { isBrandPromiseActive },
  } = useContext(EnvVarsFeaturesContext);
  const {
    userState: {
      user: { signedIn, greeting },
    },
  } = useContext(UserContext);

  const toggleMenu = e => {
    e.preventDefault();
    setIsMenuOpen(!isMenuOpen);
  };

  const formattedGreeting = formatGreeting(greeting);
  const displayedGreeting =
    formattedGreeting === '' ? 'My account' : `Hello ${formattedGreeting}`;

  const accountLinks = getAccountLinks(accountBaseUrl);

  return (
    <div className={styles.container}>
      {signedIn ? (
        <div
          className={classNames(styles.menuTrigger)}
          data-test="menu-triggers"
          onMouseEnter={e => !isTouchDevice() && toggleMenu(e)}
          onMouseLeave={e => !isTouchDevice() && toggleMenu(e)}
        >
          <div
            className={classNames(styles.account, {
              [styles.account__bp]: isBrandPromiseActive,
            })}
          >
            <AccountButton
              onClick={e => isTouchDevice() && isDesktop() && toggleMenu(e)}
              greeting={displayedGreeting}
              isBrandPromiseActive={isBrandPromiseActive}
            />
            <AccountMenu isOpen={isMenuOpen} accountLinks={accountLinks} />
          </div>
        </div>
      ) : (
        <>
          <div className={classNames(styles.signIn, styles.desktop)}>
            <a href="/sign-in">Sign in</a>
          </div>
          <AccountButton isBrandPromiseActive={isBrandPromiseActive} />
        </>
      )}
      <a
        href={`${accountBaseUrl}/wish-list`}
        className={classNames(styles.icon, styles.desktop, {
          [styles.icon__bp]: isBrandPromiseActive,
        })}
        data-test="wishlist-button"
        data-testid="wishlist-button"
        aria-label="View your wishlist"
      >
        <WishlistIcon box />
      </a>
    </div>
  );
};

export default AccountLinks;
